"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/crm/user");
var _jsMd = _interopRequireDefault(require("js-md5"));
var _lodash = _interopRequireDefault(require("lodash"));
var _vuex = require("vuex");
var _default = exports.default = {
  name: 'PageUserPwdModify',
  data() {
    return {
      form: {
        mobile: this.$store.getters.userInfo.account
      },
      loading: false
    };
  },
  computed: (0, _vuex.mapGetters)(['userId']),
  methods: {
    async onSubmit() {
      const {
        userId
      } = this;
      try {
        this.loading = true;
        await this.$refs.form.validate();
        await (0, _user.postPwdModify)(_lodash.default.omit({
          ...this.form,
          userId,
          oldPassword: (0, _jsMd.default)(this.form.oldPassword),
          newPassword: (0, _jsMd.default)(this.form.newPassword)
        }, ['_confirmPassword']));
        this.$info({
          title: '操作成功',
          content: '密码已修改，请返回登录',
          parentContext: this,
          okText: '知道了',
          onOk: async () => {
            this.$router.back('/user/login');
            await new Promise(r => _lodash.default.delay(r, 500));
            await this.$store.dispatch('ALogout', true);
          }
        });
      } finally {
        this.loading = false;
      }
    }
  }
};